// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { createEnumStyle } from "@microsoft/applicationinsights-core-js";
export var StorageType = createEnumStyle({
    LocalStorage: 0 /* LocalStorage */,
    SessionStorage: 1 /* SessionStorage */
});
export var DistributedTracingModes = createEnumStyle({
    AI: 0 /* AI */,
    AI_AND_W3C: 1 /* AI_AND_W3C */,
    W3C: 2 /* W3C */
});
//# sourceMappingURL=Enums.js.map